module.exports = __webpack_public_path__ + "img/检品配置.5d79457f.svg";